import React from 'react'
import Typography from 'material-ui/Typography'

import Title from '../ui/title'
import Content from '../ui/content'

import Back from '../ui/back'

class Customer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      logo: null
    }
  }

  render() {

    const {
      translate,
      selectedCustomer
    } = this.props

    return (
      <div>
        <Title
          logo={selectedCustomer.logo}
          title={selectedCustomer.name}
          back={<Back translate={translate} to={"/customers"} />}
        />
        <Content translate={translate}>
          <Typography type="title">
            {selectedCustomer.name}
          </Typography>
        </Content>
      </div >
    )

  }

}


export default Customer
